// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"0dc6c0fe","453":"825386d9","629":"99fdeed3","640":"e364d9ac"}[chunkId] + ".chunk.js";
};